import React, { useState } from "react"; // 1. Faltaba importar useState
import DemoModal from "./DemoModal";

const Hero = ({ onCtaClick }) => {
  // 2. Faltaba declarar el estado para controlar el modal
  const [isDemoOpen, setIsDemoOpen] = useState(false);

  return (
    <>
      {" "}
      {/* 3. Usamos un Fragment para envolver la sección y el Modal */}
      <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden">
        {/* Background Gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-indigo-50/50 to-white" />

        {/* Animated Shapes */}
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob" />
        <div className="absolute top-40 right-10 w-72 h-72 bg-indigo-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000" />
        <div className="absolute bottom-20 left-1/2 w-72 h-72 bg-purple-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000" />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-100 rounded-full border border-blue-200 mb-8">
              <span className="w-2 h-2 bg-blue-600 rounded-full animate-pulse" />
              <span className="text-xs font-bold text-blue-700 uppercase tracking-wider">
                La Plataforma #1
              </span>
            </div>

            {/* Main Heading */}
            <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight mb-6">
              <span className="bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent">
                Aprueba el examen y conviértete en
              </span>
              <br />
              <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                Corredor de Bienes Raíces
              </span>
            </h1>

            {/* Subheading */}
            <p className="text-xl md:text-2xl text-slate-600 max-w-3xl mx-auto mb-10">
              La app que más aspirantes usan en Panamá para preparar el examen
              de licencia de bienes raíces. +200 agentes ya lo lograron.
              Practica con más de 5,000 preguntas y domina la legislación
              panameña con ayuda de IA.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <button
                onClick={onCtaClick}
                className="group px-8 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-lg font-bold rounded-2xl shadow-xl shadow-blue-200 hover:shadow-2xl hover:scale-105 transition-all duration-300 flex items-center gap-2"
              >
                <span>Comienza gratis</span>
                <svg
                  className="w-5 h-5 group-hover:translate-x-1 transition-transform"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
              </button>
              <button
                onClick={() => setIsDemoOpen(true)}
                className="group relative px-8 py-4 bg-white text-slate-900 text-lg font-black rounded-2xl transition-all duration-300 hover:scale-105 active:scale-95 shadow-[0_0_20px_rgba(59,130,246,0.15)] hover:shadow-[0_0_30px_rgba(59,130,246,0.3)] flex items-center gap-3 border-2 border-transparent"
                style={{
                  background:
                    "linear-gradient(white, white) padding-box, linear-gradient(to right, #3b82f6, #818cf8) border-box",
                }}
              >
                {/* Efecto de brillo interior al hacer hover */}
                <div className="absolute inset-0 bg-blue-50 opacity-0 group-hover:opacity-100 transition-opacity rounded-2xl -z-10" />

                <div className="relative flex items-center gap-3">
                  <div className="bg-blue-600 text-white p-1 rounded-full group-hover:rotate-12 transition-transform shadow-lg shadow-blue-200">
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                    </svg>
                  </div>

                  <span className="bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent group-hover:from-blue-700 group-hover:to-indigo-600 transition-all">
                    Hacer examen de prueba
                  </span>
                </div>

                {/* Badge de "Gratis" o "Nuevo" opcional para llamar más la atención */}
                <span className="absolute -top-3 -right-3 px-2 py-1 bg-emerald-500 text-white text-[10px] font-black uppercase tracking-tighter rounded-lg shadow-lg rotate-12 group-hover:rotate-0 transition-transform">
                  Gratis
                </span>
              </button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto mt-20">
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-black text-blue-600">
                  +200
                </div>
                <div className="text-sm text-slate-600 mt-1">
                  Aspirantes preparados con nosotros
                </div>
              </div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-black text-blue-600">
                  +5k
                </div>
                <div className="text-sm text-slate-600 mt-1">
                  Preguntas prácticas
                </div>
              </div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-black text-blue-600">
                  Top rated
                </div>
                <div className="text-sm text-slate-600 mt-1">
                  La app mejor valorada por aspirantes en Panamá
                </div>
              </div>
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-black text-blue-600">
                  24/7
                </div>
                <div className="text-sm text-slate-600 mt-1">
                  Disponible desde cualquier dispositivo
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* 4. Faltaba renderizar el componente DemoModal aquí abajo */}
      <DemoModal
        isOpen={isDemoOpen}
        onClose={() => setIsDemoOpen(false)}
        onRegister={onCtaClick}
      />
    </>
  );
};

export default Hero;
